module.exports = __webpack_public_path__ + "media/images/icon-transfers-d7873d11ac899f6537b855f813119ff9.svg";